import { render, staticRenderFns } from "./SupersessionIcon.vue?vue&type=template&id=cc33d6ce"
import script from "./SupersessionIcon.vue?vue&type=script&lang=js"
export * from "./SupersessionIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports